import { httpsCallable, httpsCallableFromURL } from 'firebase/functions';
import { functions } from '../firebase.js';
import { isFirebaseHostingPreviewHost } from './turnstile.js';

/**
 * Onboarding callables rewritten through Firebase Hosting with pinTag
 * (see firebase.json). Same-origin calls avoid CORS and let preview channels
 * use a pinned function revision instead of live prod.
 */
export const HOSTING_PINNED_CALLABLES = [
  'startOnboardingSignup',
  'verifyOnboardingEmail',
  'resendOnboardingVerification',
  'createOnboardingWorkspace',
];

/**
 * @param {string} [hostname]
 * @returns {boolean}
 */
export function shouldUseHostingPinnedCallable(hostname) {
  if (typeof window === 'undefined' && !hostname) {
    return false;
  }
  if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
    return false;
  }
  const host = hostname || window.location.hostname;
  if (!host || host === 'localhost' || host === '127.0.0.1') {
    return false;
  }
  if (isFirebaseHostingPreviewHost(host)) {
    return true;
  }
  if (host.endsWith('.web.app') || host.endsWith('.firebaseapp.com')) {
    return true;
  }
  if (
    host === 'signup.bildit.co' ||
    host === 'dev.signup.bildit.co' ||
    host === 'stage.signup.bildit.co'
  ) {
    return true;
  }
  return false;
}

/**
 * Callable wrapper that uses Hosting pinTag rewrites when available.
 * @param {string} name
 * @param {import('firebase/functions').HttpsCallableOptions} [options]
 * @returns {import('firebase/functions').HttpsCallable}
 */
export function getPinnedOrDirectCallable(name, options) {
  if (
    HOSTING_PINNED_CALLABLES.includes(name) &&
    shouldUseHostingPinnedCallable()
  ) {
    const url = `${window.location.origin}/${name}`;
    return httpsCallableFromURL(functions, url, options);
  }
  return httpsCallable(functions, name, options);
}
